require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-olifantenbrug.json") })
        }
      }, "path---projecten-olifantenbrug");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-olifantenbrug!./.cache/json/projecten-olifantenbrug.json
// module id = 433
// module chunks = 231608221292675